// client/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProtectedRoute from "./components/ProtectedRoute";


function App() {
  return (
    <Router>
      <div className="App">
        <div style={centerStyle}>
          <h1 style={{ color: "#fff" }}>MFA using MERN Stack</h1>
        </div>

        <Routes>
          {/* Wrap Login inside a full-page container */}
          <Route path="/login" element={<div className="login-page"><Login /></div>} />
          <Route path="/dashboard" element={<ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

const centerStyle = {
  textAlign: 'center',
  marginTop: '20px',
};

export default App;
